export const debitCardContentBox = {
    showLockAndUnlockNavigation: true,
    showDisplayPinNavigation: true,
    showChangeCardLimitsNavigation: true,
};
